import React, { useEffect } from 'react';
import { Snackbar } from '@material-ui/core';
import { Check, AlertTriangle, InfoCircle } from 'tabler-icons-react';
import { useCapacidades } from './CapacidadesContext';
import FiltrosCapacidades from './FiltrosCapacidades';
import LineaAccordion from '../../components/LineaAccordion';
import '../../styles/capacidades.css';

export default function CapacidadesView() {
    const {
        areas,
        selectedArea,
        lines,
        lineData,
        snackbar,
        canEdit,
        getAreas,
        selectArea,
        toggleLinea,
        setCapLineaField,
        guardarCapLinea,
        setCeldaField,
        guardarCapCelda,
        resetCapCelda,
        closeSnackbar,
    } = useCapacidades();

    useEffect(() => {
        getAreas();
    }, [getAreas]);

    // Autoseleccionar la primera área al cargar.
    useEffect(() => {
        if (areas.length > 0 && !selectedArea) selectArea(areas[0]);
    }, [areas, selectedArea, selectArea]);

    return (
        <div className="capacidadesView">
            <div className="capacidadesView-head">
                <h1 className="titulo">Capacidades por default</h1>
                <p className="desc">
                    Define la capacidad de cada línea y ajusta las celdas que difieren del valor por defecto.
                </p>
            </div>

            <div className="capacidadesView-body">
                <div className="cap-card">
                    <FiltrosCapacidades />
                    {lines.length === 0 ? (
                        <div className="cap-empty">No hay líneas para el área seleccionada</div>
                    ) : (
                        <div className="cap-acordeon">
                            {lines.map((line) => {
                                const ld = lineData[line.id] || {};
                                return (
                                    <LineaAccordion
                                        key={line.id}
                                        linea={line}
                                        capLinea={ld.capLinea}
                                        lineaSaving={ld.lineaSaving}
                                        lineaEditable={false}
                                        celdasCap={ld.celdas || []}
                                        loading={ld.loading}
                                        expanded={!!ld.expanded}
                                        canEdit={canEdit}
                                        onToggle={() => toggleLinea(line.id)}
                                        onChangeLineaField={(key, val) => setCapLineaField(line.id, key, val)}
                                        onGuardarLinea={() => guardarCapLinea(line.id)}
                                        onChangeCeldaField={(celdaId, key, val) => setCeldaField(line.id, celdaId, key, val)}
                                        onGuardarCelda={(celdaId) => guardarCapCelda(line.id, celdaId)}
                                        onResetCelda={(celdaId) => resetCapCelda(line.id, celdaId)}
                                    />
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={closeSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <div className={`app-notif app-notif--${snackbar.severity}`}>
                    {snackbar.severity === 'success' && <Check size={20} strokeWidth={2} color="#fff" />}
                    {snackbar.severity === 'error' && <AlertTriangle size={20} strokeWidth={2} color="#fff" />}
                    {snackbar.severity === 'info' && <InfoCircle size={20} strokeWidth={2} color="#fff" />}
                    <span className="app-notif__msg">{snackbar.msg}</span>
                    <div className="app-notif__progress" />
                </div>
            </Snackbar>
        </div>
    );
}
